export function useUpdateUrlQuery() {
  const router = useRouter()

  function hasValue(value: any) {
    if (value === null || value === undefined) {
      return false
    }

    if (Array.isArray(value)) {
      return value.length > 0
    }

    if (typeof value === 'object') {
      return Object.keys(value).length > 0
    }

    return value !== ''
  }

  function setQueryByKey({
    key,
    value,
    routerActionType = 'replace',
  }: {
    key: string
    value?: any
    routerActionType?: 'replace' | 'push'
  }) {
    const queryParams = new URLSearchParams(window.location.search)

    if (hasValue(value)) {
      queryParams.set(key, encodeURIComponent(JSON.stringify(value)))
    } else {
      queryParams.delete(key)
    }

    // No idea why, but this line is important, without this line, other updates will replace the queries
    // for example, in listing (plain, not map), reset filter, go to page 2, then try to filter by price
    // doesn't work right? Dunno why, but this line fixes it
    window.history.replaceState(
      {},
      '',
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    )

    const query = {} as Record<string, string>
    for (const [qKey, qValue] of queryParams.entries()) {
      query[qKey] = qValue
    }

    router.push({
      query,
      replace: routerActionType !== 'push',
    })
  }

  function getQueryByKey(key: string): Record<string, any> | null {
    try {
      const route = useRoute()
      const urlQueryValues = JSON.parse(
        decodeURIComponent(route.query?.[key]?.toString() || '') || '{}'
      )

      return urlQueryValues
    } catch (error) {
      console.warn("Couldn't parse filter from URL", error)
    }

    return null
  }

  function hasQueryByKey(key: string) {
    const route = useRoute()

    return route.query?.[key] !== undefined
  }

  function deleteQueryByKey(key: string) {
    const queryParams = new URLSearchParams(window.location.search)
    queryParams.delete(key)

    window.history.replaceState(
      {},
      '',
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    )

    const query = {} as Record<string, string>
    for (const [qKey, qValue] of queryParams.entries()) {
      query[qKey] = qValue
    }

    router.replace({
      query,
    })
  }

  return {
    setQueryByKey,
    getQueryByKey,
    hasQueryByKey,
    deleteQueryByKey,
  }
}
